import { Navigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { useEffect, useState } from "react";

export default function PublicRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const { data } = await supabase.auth.getUser();
      setUser(data?.user || null);
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) return <div className="p-5">Loading...</div>;

  // If logged in → redirect to home
  if (user) {
    alert("You are already logged in. Logout first to access login/signup.");
    return <Navigate to="/" replace />;
  }

  return children;
}
